import React from 'react';
import Select from 'react-select';
import {connect} from 'react-redux';
import actions from 'actions/index';

const {
  adminUserFilter
} = actions;

class EditAdminUsersSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showOptions: true,
      users: [],
      user_ids: [],
      page: 1,
      per_page: 50,
      searchQuery: {
        order: {
          created_at: 'desc'
        },
        ...props.query
      }
    }
    this.onInputChange = this.onInputChange.bind(this);
  }

  componentWillMount = () => {
    this.updateUsersList();
  }

  updateUsersList = () => {
    const {
      page,
      searchQuery,
      per_page
    } = this.state;

    this.props.userFilter(searchQuery, page, 5000);

  }

  onInputChange(newTextValue) {
    if( newTextValue.length === 1 ) {
      this.setState({ showOptions : false } )
    }  else {
      this.setState( { showOptions : true } )
    }
    const searchQuery = {
      ...this.state.searchQuery,
      q: newTextValue
    }
    //this.setState({ searchQuery }, this.updateUsersList)
    return newTextValue;
  }

  render () {
    const {value, onChange, errors} = this.props;
    return (
      <div>
        <div className="col s12">
          <Select
            options={this.state.showOptions ? this.props.users && this.props.users.map(user => ({value: user.id, label: user.full_name})) : []}
            placeholder='Select users'
            value={value}
            onChange={onChange}
            multi={true}
            onInputChange={this.onInputChange}
            isSearchable={true}
          />
          <div style={{ color: 'red', fontSize: '0.875rem' }}>
            {(errors || []).join('. ')}
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    users: state.users.adminUsers.values,
    query: state.users.adminUsers.query
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    userFilter: (query, page, per_page) => dispatch(adminUserFilter(query, page, per_page))
  };
}

export default connect(mapStateToProps, mapDispatchToProps) (EditAdminUsersSelect);



// WEBPACK FOOTER //
// ./src/containers/Input/EditAdminUsersSelect.jsx